<template>
  <div v-if="!isMobile()">
    <div class=" clear-filter drago-wrap" filter-color="black">
      <div class="page-header-image2 bg">
        <div class="bg-wrap"></div>
        <video
          id="pc-bganimation"
          autoplay=""
          loop=""
          preload="auto"
          muted="muted"
        >
          <source src="/video/bg_drago.mp4?v=20220512" type="video/mp4" />
        </video>
      </div>
      <div id="top" class="drago-main-wrap">
        <h2>
          DRAGO
        </h2>
        <p>
          Adopt your Drago to start earning $DST!
        </p>
      </div>
    </div>
    <dragologistic-section></dragologistic-section>
  </div>
  <div v-else>
    <div class="page-header clear-filter" filter-color="black2">
      <parallax
        class="page-header-image"
        style="background-image: url('/img/img_m_drago.png')"
      ></parallax>
      <div class="container" id="top">
        <div class="row" style="margin-top: 15vh">
          <div style="margin: auto">
            <h1
              class="h1"
              style="
                text-align: center;
                font-size: 50px;
                font-weight: 900;
                text-transform: uppercase;
                margin-right: 20px;
                margin-left: 20px;
                color: #ffffff;
                margin-bottom: 10px !important;
              "
            >
              {{ $t("drago_title") }}
            </h1>
          </div>
          <div style="width: 85%; margin: auto">
            <h5
              class="description"
              style="
                font-size: 16px;
                font-weight: 300;
                text-align: center;
                color: #ffffff;
              "
            >
              {{ $t(`drago_description`) }}
            </h5>
          </div>
        </div>
        <div class="row" style="margin-top: 25vh">
          <div style="margin: auto">
            <h1
              class="h1"
              style="
                text-align: center;
                font-size: 50px;
                font-weight: 900;
                text-transform: uppercase;
                margin-right: 20px;
                margin-left: 20px;
                color: #ffffff;
                margin-bottom: 10px !important;
              "
            >
              {{ $t("lok_title") }}
            </h1>
          </div>
          <div class="col-lg-1"></div>
          <div style="width: 85%; margin: auto">
            <h5
              class="description"
              style="
                font-size: 24px;
                font-weight: 600;
                text-align: center;
                color: #ffffff;
              "
            >
              ({{ $t(`Soul of Dragos`) }})
            </h5>
            <h5
              class="description"
              style="
                font-size: 16px;
                font-weight: 300;
                text-align: center;
                color: #ffffff;
              "
            >
              {{ $t(`lok_description`) }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <dragologistic-section></dragologistic-section>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import DragologisticSection from "./components/DragoLogisticSection.vue";

export default {
  name: "drago",
  bodyClass: "drago-page",
  components: {
    Parallax,
    DragologisticSection,
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
  /* body .drago-wrap {
    min-height: 1000px;
  } */
  #pc-bganimation {
    width: 100%; height: 100vh;
    object-fit: cover;
  }
  .bg-wrap {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%;
    background-color: rgba(0,0,0,.3);
    /* background-image: radial-gradient(rgba(0,0,0,.1) 1px, transparent 0);
    background-size: 5px 5px;
    background-position: -19px -19px; */
    z-index: 0;
}
  .drago-main-wrap {
    position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
  }
  .drago-main-wrap h2 {
    margin: 0 0 60px;
    line-height: 1; text-align: center;
    color: #fff; font-size: 120px; font-weight: 700; letter-spacing: -1.2px;

  }
  .drago-main-wrap p {
    margin: 0;
    line-height: 1;
    color: #fff; font-size: 28px; font-weight: 600; 
    text-align: center;
  }
</style>
